import {
  Autocomplete, CircularProgress,
  TextField,
} from "@mui/material";
import React from "react";
import { AppForm, AppFormProps } from "../../../core/form/AppForm";
import { NewProductVersionDto, NewProductVersionExtraProps } from "./useNewProductVersionProfile";
import { ProductVersionDto } from "../../../models/domain/ProductVersionDto";
import {
  ProductVersionStatusSelect
} from "../../../comps/fields/product-version-status-select/ProductVersionStatusSelect";

export const NewProductVersionProfileForm = (props: AppFormProps<NewProductVersionDto, ProductVersionDto, NewProductVersionExtraProps>) => {
  const {versionSourcesQuery: {data: versionSources, isFetching: isVersionSourcesFetching}} = props;

  return (
    <AppForm {...props} formLabel="Product Version Profile" controls={{showEdit: false, showCancel: false}}>
      {({values, handleChange, handleBlur, touched, errors, setFieldValue}) => (
        <>
          <fieldset>
            <TextField
              id="name"
              name="name"
              label="Product Version Name"
              variant="standard"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
            />
            <ProductVersionStatusSelect
              id="productVersionStatus"
              name="productVersionStatus"
              label="Version Status"
              variant="standard"
              value={values.productVersionStatus}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.productVersionStatus && Boolean(errors.productVersionStatus)}
              helperText={touched.productVersionStatus && errors.productVersionStatus}
            />
          </fieldset>
          <fieldset>
            <Autocomplete<number>
              id="versionSourceId"
              options={versionSources?.data?.items?.map(x => x.id) ?? []}
              getOptionLabel={option => {
                return versionSources?.itemsMap && versionSources?.itemsMap[option]
                  ? versionSources?.itemsMap[option].sourcePath
                  : "N/A";
              }}
              value={values.versionSourceId}
              onChange={(_, value) => setFieldValue("versionSourceId", value)}
              onBlur={handleBlur}
              renderInput={(params) =>
                <TextField {...params}
                           variant="standard"
                           label="Linked Version Source"
                           onBlur={handleBlur}
                           onKeyDown={event => event.preventDefault()}
                           error={touched.versionSourceId && Boolean(errors.versionSourceId)}
                           helperText={touched.versionSourceId && errors.versionSourceId}
                />
              }

            />
            {isVersionSourcesFetching && <CircularProgress sx={{ml: 2}}/>}
          </fieldset>
        </>
      )}
    </AppForm>
  );
};